export const TITLE = 'Now, enter their address';
export const TITLE_SELF = 'Now, enter your address';

export const DESCRIPTION = 'We’ll look for this person’s pharmacy records.';
export const DESCRIPTION_SELF = 'We’ll combine it with your other info to search for your records.';

export const SUBMIT_BUTTON_TEXT = 'Search';

export const ADDRESS_FORM_LABELS = {
  STREET_ADDRESS: 'Street address',
  UNIT: 'Unit, apartment, etc. (optional)',
  CITY: 'City',
  STATE: 'State',
  ZIP_CODE: 'ZIP code',
  MEMBER_ID: 'Member ID (optional)',
  DATE_OF_BIRTH: 'Date of birth'
};

export const DEMOGRAPHIC_ERROR_TITLES = {
  DEFAULT: 'We need you to check something'
};

export const DEMOGRAPHIC_VALIDATION = {
  FIRST_NAME_REQUIRED: 'Enter a first name',
  FIRST_NAME_INVALID: 'First name cannot exceed 40 characters',
  LAST_NAME_REQUIRED: 'Enter a last name',
  LAST_NAME_INVALID: 'Last name cannot exceed 40 characters',
  STREET_ADDRESS_REQUIRED: 'Enter a street address',
  STREET_ADDRESS_INVALID: 'Street address cannot exceed 40 characters',
  UNIT_INVALID: 'Unit, apartment, etc. (optional) cannot exceed 40 characters',
  CITY_REQUIRED: 'Enter a city',
  STATE_REQUIRED: 'Select a 2-character abbreviated state',
  STATE_INVALID: 'Select a valid 2-character abbreviated state',
  ZIP_CODE_REQUIRED: 'Enter a 5-digit ZIP code',
  ZIP_CODE_INVALID: 'Enter a valid 5-digit ZIP code',
  DATE_OF_BIRTH_REQUIRED: 'Enter an 8-digit date of birth',
  DATE_OF_BIRTH_INVALID: 'Enter a valid 8-digit date of birth'
};

export const ADDRESS_FORM_HELP_TEXT = {
  CITY: '',
  STATE: '',
  ZIP_CODE: '',
  DATE_OF_BIRTH: 'MMDDYYYY',
  PHONE_NUMBER: 'Enter the number on file with the pharmacy.',
  MEMBER_ID: 'Your Member ID number can be found on your prescription or insurance card',
  SECOND_ATTEMPT: {
    STREET_ADDRESS: '',
    UNIT: '',
    CITY: '',
    STATE: '',
    ZIP_CODE: '',
    DATE_OF_BIRTH: 'Patient’s date of birth \n MMDDYYYY'
  }
};
